import { useState, useEffect } from 'react';
import { getShortWeather } from '../../api/weatherApi';
import { resolveWeatherTimeKey, formatPrecipitation } from '../../utils/weatherTransform';
import { isDomestic } from '../../utils/regionUtil';
import WeatherDetail from './WeatherDetail';
import WeatherIcon from '../WeatherIcon/WeatherIcon';
import { WeatherItemContainer } from './WeatherItem.styles';

// 해외 지역 배지 아이콘 (지구본). 국내(디폴트)는 배지 없이 시간만 표시.
const GLOBE = (
    <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.8">
        <circle cx="12" cy="12" r="9" />
        <ellipse cx="12" cy="12" rx="4" ry="9" />
        <path d="M3 12h18M4.5 8h15M4.5 16h15" />
    </svg>
);

const formatTime = (hour, minute) => {
    if (!hour) return "";
    let h = parseInt(hour);
    let suffix = h >= 12 ? "PM" : "AM";
    let h12 = h > 12 ? h - 12 : h === 0 ? 12 : h;
    return h12 + ":" + minute + " " + suffix;
};

const WeatherItem = ({ data, onLoadStart, onLoad }) => {
    const [state, setState] = useState({ title: data.title });
    const [showDetail, setShowDetail] = useState(null);

    const fetchWeather = (location, target) => {
        if (onLoadStart) onLoadStart();

        getShortWeather({ lat: location.lat, lng: location.lot }, (timeData) => {
            let dateKey = resolveWeatherTimeKey(data, target);
            let weatherData = timeData[dateKey];
            weatherData.date = dateKey;

            let { type: weatherType, icon: weatherIcon, precipitation } = formatPrecipitation(weatherData);

            let dateData = {};
            let prefix = target;
            dateData[prefix + "Temp"] = weatherData.TMP;
            dateData[prefix + "Weather"] = weatherType;
            dateData[prefix + "RainRate"] = weatherData.POP;
            dateData[prefix + "Precipitation"] = precipitation;
            dateData[prefix + "Date"] = weatherData.date;
            dateData[prefix + "WeatherIcon"] = weatherIcon;
            dateData[prefix + "Time"] = target === "start"
                ? data.startHour + data.startMinute
                : data.destHour + data.destMinute;
            dateData[prefix + "Humidity"] = weatherData.REH;
            dateData[prefix + "WindSpeed"] = weatherData.WSD;

            onLoad({ ...dateData });
            setState(prev => ({ ...prev, ...dateData }));
        });
    };

    useEffect(() => {
        fetchWeather({ lat: data.startLat, lot: data.startLot }, "start");
        fetchWeather({ lat: data.destLat, lot: data.destLot }, "dest");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggleDetail = (target) => {
        setShowDetail(showDetail === target ? null : target);
    };

    const renderSide = (prefix, time) => {
        const lat = prefix === "start" ? data.startLat : data.destLat;
        const lot = prefix === "start" ? data.startLot : data.destLot;
        return (
            <div
                className={'weatherSide' + (showDetail === prefix ? ' active' : '')}
                onClick={() => toggleDetail(prefix)}
            >
                <span className="timeLb">
                    {!isDomestic(lat, lot) && <span className="regionMark">{GLOBE}</span>}
                    {time}
                </span>
                <div className="weatherContent">
                    <div className="iconWrap">
                        {state[prefix + "WeatherIcon"] &&
                            <WeatherIcon name={state[prefix + "WeatherIcon"]} size={48} />
                        }
                    </div>
                    <div className="dataWrap">
                        <span className="tempLb">
                            {state[prefix + "Temp"]}
                            {state[prefix + "Temp"] && <sup>°</sup>}
                        </span>
                        <span className="rainLb">
                            {state[prefix + "RainRate"]}
                            {state[prefix + "RainRate"] && <sup>%</sup>}
                        </span>
                        {state[prefix + "Precipitation"] &&
                            <span className="precipLb">{state[prefix + "Precipitation"]}</span>
                        }
                    </div>
                </div>
            </div>
        );
    };

    return (
        <WeatherItemContainer>
            <div className="itemTitle">{state.title}</div>
            <div className="weatherRow">
                {renderSide("start", formatTime(data.startHour, data.startMinute))}
                <div className="divider" />
                {renderSide("dest", formatTime(data.destHour, data.destMinute))}
            </div>
            {showDetail &&
                <WeatherDetail
                    prefix={showDetail}
                    state={state}
                    locationLabel={showDetail === "start" ? data.startLb : data.destLb}
                />
            }
        </WeatherItemContainer>
    );
};

export default WeatherItem;
